/**
 * Helper
 */
var helper = require('../../helper'),
		dataTables_buttons = [
			{
				extend: 'csv',
				text: 'Export as CSV',
				exportOptions: {
					columns: [0, 1, 2, 3, 4, 5, 6, 7]
				},
			},
			{
				extend: 'pdf',
				text: 'Export as PDF',
				exportOptions: {
					columns: [0, 1, 2, 3, 4, 5, 6, 7]
				},
				orientation: 'landscape'
			},
			{
				extend: 'print',
				text: 'Print table',
				exportOptions: {
					columns: [0, 1, 2, 3, 4, 5, 6, 7]
				}
			},
			{
				extend: 'colvis',
			}
		];

$(function () {
	var $datatable = $('#datatable-all-rents'),
			$dt;

	$dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
		"processing": true,
		"serverSide": true,
		"stateSave": true,
		"responsive": true,
		"lengthMenu": [[30, 10, 25, 50, 75, 100], [30, 10, 25, 50, 75, 100]],

		"ajax": {
			"url": helper.getOrigin() + "/api/rents",
			"method": 'POST',

		},
		"autoWidth": false,
		"buttons": dataTables_buttons,
		"order": [[0, "asc"]],
		"columns": [
			{data: 'unique_guardian_number', name: 'guardians.unique_guardian_number'},
			{data: 'guardianName', name: 'guardianName'},
			{data: 'guardianStatus', name: 'guardianStatus'},
			{data: 'roomName', name: 'roomName'},
			{data: 'propertyName', name: 'propertyName'},
			{data: 'date_start', name: 'date_start'},
			{data: 'date_end', name: 'date_end'},
			{data: 'guardianOfficerName', name: 'guardianOfficerName'},
			{data: 'status', name: 'status', orderable: false, searchable: false},
			{
				data: 'actions',
				name: 'actions',
				orderable: false,
				searchable: false,
				className: "action"
			} // 5
		],
		"initComplete": function (settings, json) {

		}
	});


});
